import {
    mdiLogout,
    mdiMessageQuestionOutline,
    mdiMessageTextOutline,
} from '@mdi/js'
import {iconProfile} from '@shared/helpers/icons'
import {
    Link,
    NavLink,
} from 'react-router-dom'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {AppConfig} from '../../../../AppConfig'
import {appUrl} from '../../../../AppUrl'
import {Blinker} from '../../../../components/Blinker'
import {trans} from '../../../../helpers'
import {
    useAccountFlagsStore,
    useAuthStore,
} from '../../../../stores'

// Ссылки на разделы ЛК пользователя.
export function CabinetSideMenuLinks() {
    const hasNewChatMessages = useAccountFlagsStore(
        state => state.hasNewChatMessages
    )
    const hasNewSupportTicketReplies = useAccountFlagsStore(
        state => state.hasNewSupportTicketReplies
    )
    const logout = useAuthStore(
        state => state.logout
    )

    return (
        <div
            id="cabinet-side-menu-links"
            className="d-flex gap-3 flex-column align-items-stretch"
        >
            <Card>
                <CardBody>
                    <div>
                        <NavLink
                            to={appUrl().cabinet.ads.index}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.my_ads}
                        </NavLink>
                    </div>
                    <div>
                        <NavLink
                            to={appUrl().cabinet.executors.index}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.my_services}
                        </NavLink>
                    </div>
                    <div>
                        <NavLink
                            to={appUrl().cabinet.reviews}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.my_reviews}
                        </NavLink>
                    </div>
                    <div>
                        <NavLink
                            to={appUrl().cabinet.favorites}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.my_favorites}
                        </NavLink>
                    </div>
                    <div>
                        <NavLink
                            to={appUrl().cabinet.subscriptions}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.my_subscriptions}
                        </NavLink>
                    </div>
                </CardBody>
            </Card>
            <Card>
                <CardBody>
                    <div className="flex-row-between">
                        <NavLink
                            to={appUrl().cabinet.chats.index}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.my_chats}
                        </NavLink>
                        {hasNewChatMessages && (
                            <Blinker repeats={3}>
                                <Icon
                                    path={mdiMessageTextOutline}
                                    tooltip={trans().cabinet.side_navigation.has_new_chat_messages}
                                    size={20}
                                    color="blue"
                                />
                            </Blinker>
                        )}
                    </div>
                    <div>
                        <NavLink
                            to={appUrl().cabinet.notifications.index}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.notifications}
                        </NavLink>
                    </div>
                    <div className="flex-row-between">
                        <NavLink
                            to={appUrl().cabinet.supportTickets.index}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.support_tickets}
                        </NavLink>
                        {hasNewSupportTicketReplies && (
                            <Blinker repeats={3}>
                                <Icon
                                    path={mdiMessageQuestionOutline}
                                    tooltip={trans().cabinet.side_navigation.has_new_support_ticket_replies}
                                    size={20}
                                    color="orange"
                                />
                            </Blinker>
                        )}
                    </div>
                    <div>
                        <NavLink
                            to={NavigationService.makeUrl(
                                appUrl().cabinet.advancePayments.surveyForm,
                                null,
                                {step: '1'}
                            )}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.client_data}
                        </NavLink>
                    </div>
                    {AppConfig.features?.advances?.enabled && (
                        <div>
                            <NavLink
                                to={appUrl().cabinet.advancePayments.contract}
                                className="side-nav-link"
                            >
                                {trans().cabinet.side_navigation.active_contract}
                            </NavLink>
                        </div>
                    )}
                    <div>
                        <NavLink
                            to={appUrl().cabinet.transactions.index}
                            className="side-nav-link"
                        >
                            {trans().cabinet.side_navigation.transactions}
                        </NavLink>
                    </div>
                    <div className="side-nav-separator" />
                    <div>
                        <NavLink
                            to={appUrl().cabinet.settings.index}
                            className="side-nav-link with-icon-flex gap-2"
                        >
                            <Icon
                                path={iconProfile}
                            />
                            {trans().cabinet.side_navigation.settings}
                        </NavLink>
                    </div>
                    <div>
                        <Link
                            to={appUrl().logout}
                            className="side-nav-link with-icon-flex gap-2"
                            onClick={e => {
                                e.preventDefault()
                                logout()
                            }}
                        >
                            <Icon
                                path={mdiLogout}
                            />
                            {trans().cabinet.side_navigation.logout}
                        </Link>
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}
